/*
 * @Author: WUJUN
 * @Date: 2019-07-09 11:52:34
 * @Description:
 */
import axios from 'axios';
import { Toast } from 'vant';
import qs from 'querystring';
import Vue from 'vue';
import store from '@/store';

const innitConfig = {
  withCredentials: true,
  timeout: 20000,
  cache: false,
  headers: {
    baseURL: '/',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
};

const Axios = axios.create(innitConfig);
Axios.interceptors.request.use(
  (config) => {
    // 传递json型参数
    if (config.requestBody) {
      config.headers['Content-Type'] = 'application/json';
      return config;
    }
    config.data = decodeURIComponent(qs.stringify(config.data)); // 转为formdata数据格式
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
Axios.interceptors.response.use(
  (response) => {
    Toast.clear(true);
    if (response.data) {
      const res = response.data;
      if (res.code && res.code == 0) {
        return res;
      } else if (res.code == 20003) {
        Vue.prototype.$_dialog.freeze();
      } else if (res.code == 1013) {
        Toast('服务异常');
      } else if (res.code === '20001') {
        Toast(res.msg || '账号异常禁止登陆');
        setTimeout(() => {
          PLUGIN.delUserInfo();
          store.commit('SET_IS_LOGIN', false);
          //TODO 使用统一登录弹框
          new PLUGIN().login({
            success() {
              window.location.reload();
            }
          });
        }, 600);
      } else {
        Toast(res.msg || '程序发生异常，请联系管理员！');
      }
    }
    return Promise.reject(response.data);
  },
  (error) => {
    Toast('服务异常');
    return Promise.reject('error');
  }
);
export default Axios;



// WEBPACK FOOTER //
// src/utils/request.js